import { TimingOptions } from "api/model/dashboard/DashboardReportOptions";
import { T } from "services/lang/LanguageService";
import React from "react";
import { Leaves, setObjAttribute } from "utils/utils";
import { Input } from "../InputCategories";

type TimingOptionsKey = Leaves<TimingOptions>;

export const TimingOptionsSubForm = (props: {
  timingOptions: TimingOptions;
  onChange: (o: TimingOptions) => void;
}) => {
  const onChangeTimingOptions = (prop: TimingOptionsKey, value: any) => {
    const newTimingOptions = { ...props.timingOptions };
    setObjAttribute(newTimingOptions, prop, value);
    props.onChange(newTimingOptions);
  };

  return (
    <React.Fragment>
      <h5 className="mb-5">{T("word.timing-options")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-12 mb-4">
          <Input.Text
            id="input-timing-options-gen-cron"
            label={T("label.generation-cron-quartz")}
            property={"generationCron"}
            sourceObj={props.timingOptions}
            onChange={onChangeTimingOptions}
          />
        </span>

        <span className="p-float-label col-12 md:col-4 mb-4">
          <Input.Text
            id="input-timing-options-truncate-to"
            label={T("label.reference-time-truncate-align-unit")}
            property={"referenceTimeTruncateTo"}
            sourceObj={props.timingOptions}
            onChange={onChangeTimingOptions}
          />
        </span>

        <span className="p-float-label col-12 md:col-4 mb-4">
          <Input.Number
            id="input-timing-options-offset"
            label={T("label.reference-time-offset")}
            property={"referenceTimeOffset"}
            sourceObj={props.timingOptions}
            onChange={onChangeTimingOptions}
          />
        </span>

        <span className="p-float-label col-12 md:col-4 mb-4">
          <Input.Text
            id="input-timing-options-offset-unit"
            label={T("label.reference-time-offset-unit")}
            property={"referenceTimeOffsetUnit"}
            sourceObj={props.timingOptions}
            onChange={onChangeTimingOptions}
          />
        </span>

        <span className="p-float-label col-12 md:col-12">
          <Input.Text
            id="input-timing-options-datetime-format"
            label={T("label.date-time-display-format")}
            property={"reportTimeFormat"}
            sourceObj={props.timingOptions}
            onChange={onChangeTimingOptions}
          />
        </span>
      </div>
    </React.Fragment>
  );
};
